/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_Access_Conflict_DescriptionInputs */



/**
* | output |
* | --- |
* | "{count} member(s) with access conflicts to linked spaces. AI responses may be incomplete for affected users." |
*
* @param {Project_Access_Conflict_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_conflict_description = /** @type {((inputs: Project_Access_Conflict_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Conflict_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Mitglied(er) mit Zugriffskonflikten zu verknüpften Spaces. KI-Antworten können für betroffene Nutzer unvollständig sein.`)
	return /** @type {LocalizedString} */ (`${i?.count} member(s) with access conflicts to linked spaces. AI responses may be incomplete for affected users.`)
});